import { type ExportFormat, saveFile } from '@features/allocation';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { projectListService } from '../services/projectListService';
import type { ProjectExportScope, ProjectFilters } from '../types/ProjectList';
import type { ProjectColumn } from './useProjectColumns';

type ExportRequest = { format: ExportFormat; scope: ProjectExportScope };

/** Exporta com os filtros, a ordem e as colunas da tela: tudo ou só a página atual (`pageSize` linhas). */
export function useExportProjectList(
  { page, perPage: _perPage, ...filters }: ProjectFilters,
  pageSize: number,
  columns: readonly ProjectColumn[],
) {
  const { t, i18n } = useTranslation('projetos');
  const language = i18n.resolvedLanguage === 'en-US' ? 'en-US' : 'pt-BR';

  return useMutation({
    mutationFn: ({ format, scope }: ExportRequest) =>
      projectListService.exportSpreadsheet(
        filters,
        { format, language, columns },
        scope === 'page' ? { page, perPage: pageSize } : undefined,
      ),
    onSuccess: ({ file, fileName }, { format }) =>
      saveFile(file, fileName ?? `${t('exportacao.nomeArquivo')}.${format}`),
  });
}

export type ProjectExport = ReturnType<typeof useExportProjectList>;
